import { render, staticRenderFns } from "./ChangesDialog.vue?vue&type=template&id=52a6da72"
import script from "./ChangesDialog.vue?vue&type=script&lang=js"
export * from "./ChangesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports